import PropTypes from 'prop-types'
import React from 'react'

import CtaLink from '../CtaLink'

import './styles.css'

// Post-signup hero (SPEC-052 FR-9, SPEC-053 FR-4): the production course
// header's treatment — the artwork full and clean on one side, a solid
// content panel on the other — translated to the page's dark palette. No
// scrim wash over the image; it either shows properly or (no upload) the
// panel takes the full width. All copy is content-managed.
function LeadMagnetHero({
  eyebrow = '',
  heading,
  subheading = '',
  watchCtaLabel = 'Watch lesson 1',
  trialCtaLabel = 'Start 7-day free trial',
  trialCtaUrl = '/subscriptions/plans',
  backgroundImage = '',
  showWatchCta = false,
  showTrialCta = false,
  onWatchFirst
}) {
  return (
    <header className={`lm-hero${backgroundImage ? '' : ' -no-media'}`}>
      {backgroundImage && (
        <div
          className="lm-hero__media"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}
      <div className="lm-hero__panel">
        {eyebrow && <span className="lm-hero__eyebrow">{eyebrow}</span>}
        <h1 className="lm-hero__title">{heading}</h1>
        {subheading && <p className="lm-hero__subtitle">{subheading}</p>}
        {(showWatchCta || showTrialCta) && (
          <div className="lm-hero__actions">
            {showWatchCta && (
              <button
                type="button"
                className="btn -orange lm-hero__cta"
                onClick={onWatchFirst}
              >
                {watchCtaLabel}
              </button>
            )}
            {showTrialCta && (
              <CtaLink to={trialCtaUrl} className="btn -border-white lm-hero__cta">
                {trialCtaLabel}
              </CtaLink>
            )}
          </div>
        )}
      </div>
    </header>
  )
}

LeadMagnetHero.propTypes = {
  eyebrow: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  watchCtaLabel: PropTypes.string,
  trialCtaLabel: PropTypes.string,
  trialCtaUrl: PropTypes.string,
  backgroundImage: PropTypes.string,
  showWatchCta: PropTypes.bool,
  showTrialCta: PropTypes.bool,
  onWatchFirst: PropTypes.func.isRequired
}

export default LeadMagnetHero
